import { normalizeCountryCode } from '@insio/countries';
import type { Address } from '../../../../graphql/generated/graphql';

export interface AddressFormState {
  streetName: string;
  buildingNumber: string;
  city: string;
  postalCode: string;
  countryCode: string;
}

export const EMPTY_FORM: AddressFormState = {
  streetName: '',
  buildingNumber: '',
  city: '',
  postalCode: '',
  countryCode: ''
};

export function toFormState(value: Address | null | undefined): AddressFormState {
  return {
    streetName: value?.streetName ?? '',
    buildingNumber: value?.buildingNumber ?? '',
    city: value?.city ?? '',
    postalCode: value?.postalCode ?? '',
    countryCode: value?.countryCode ?? ''
  };
}

export function toAddress(form: AddressFormState): Address | null {
  const isEmpty =
    !form.streetName.trim() &&
    !form.buildingNumber.trim() &&
    !form.city.trim() &&
    !form.postalCode.trim() &&
    !form.countryCode.trim();
  if (isEmpty) return null;
  return {
    streetName: form.streetName.trim() || null,
    buildingNumber: form.buildingNumber.trim() || null,
    city: form.city.trim() || null,
    postalCode: form.postalCode.trim() || null,
    countryCode: normalizeCountryCode(form.countryCode) ?? null
  };
}
